export default "<p n2p-dropdown-item=\"\">\n  {{ 'DROPDOWN_DATA.NO_SEARCH_RESULTS' | translate }}\n</p>\n"